document.addEventListener('DOMContentLoaded', () => {

    console.log('SW Homepage JavaScript loaded');

    // Mobile Menu
    const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
    const mainNav = document.querySelector('.main-nav');

    if (mobileMenuBtn && mainNav) {

        mobileMenuBtn.addEventListener('click', () => {
            mainNav.classList.toggle('open');
        });

        document.addEventListener('click', (e) => {
            if (
                mainNav.classList.contains('open') &&
                !mainNav.contains(e.target) &&
                !mobileMenuBtn.contains(e.target)
            ) {
                mainNav.classList.remove('open');
            }
        });
    }

    initSwipers();

});


function initSwipers() {

    if (typeof Swiper === 'undefined') return;

    // Hero Swiper
    const heroEl = document.querySelector('.hero-swiper');
    if (heroEl && !heroEl.swiper) {

        // Looping needs at least 3 slides; with fewer, go back to the first slide after the last instead
        const heroSlides = heroEl.querySelectorAll('.hero-slide').length;

        // Seconds per slide comes from the Landing Hero section setting (defaults to 8)
        const heroSeconds = parseInt(heroEl.dataset.autoplay, 10) || 8;

        // Visitors who ask their device to reduce motion don't get automatic rotation
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const heroSwiper = new Swiper(heroEl, {
            direction: 'horizontal',
            loop: heroSlides > 2,
            rewind: heroSlides <= 2,
            speed: reduceMotion ? 0 : 300,
            autoplay: {
                delay: heroSeconds * 1000,
                // Hold the current slide while the mouse is over the slider, so longer copy can be read
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            a11y: {
                enabled: true,
            },
        });

        // Pause / play button
        const toggle = heroEl.querySelector('[data-hero-toggle]');
        const setToggle = (playing) => {
            if (!toggle) return;
            toggle.dataset.state = playing ? 'playing' : 'paused';
            toggle.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        };

        if (reduceMotion) heroSwiper.autoplay.stop();
        setToggle(heroSwiper.autoplay.running);

        heroSwiper.on('autoplayStart', () => setToggle(true));
        heroSwiper.on('autoplayStop', () => setToggle(false));

        if (toggle) {
            toggle.addEventListener('click', () => {
                if (heroSwiper.autoplay.running) {
                    heroSwiper.autoplay.stop();
                } else {
                    heroSwiper.autoplay.start();
                }
            });
        }
    }

    // Deals and Best Selling Swipers (one per section, so each section's arrows control only its own carousel)
    document.querySelectorAll('.limited-time-deals').forEach((section) => {

        const el = section.querySelector('.deals-swiper');
        if (!el || el.swiper) return;

        // Center the arrows on the product photos, not the whole card
        const alignArrows = () => {
            const img = el.querySelector('.product-image-wrap');
            if (!img) return;
            const top = img.offsetTop + img.offsetHeight / 2;
            section.querySelectorAll('.sw-arrow').forEach((arrow) => {
                arrow.style.top = top + 'px';
            });
        };

        new Swiper(el, {
            // Phones: one and a half cards, so the next product peeks in and invites a swipe
            slidesPerView: 1.5,
            spaceBetween: 12,
            loop: true,
            grabCursor: true,
            navigation: {
                nextEl: section.querySelector('.sw-arrow--next'),
                prevEl: section.querySelector('.sw-arrow--prev'),
            },
            // Step up gradually with screen width (sizes are the browser window width)
            breakpoints: {
                480: { slidesPerView: 2, spaceBetween: 16 },   // large phones, phones in landscape
                640: { slidesPerView: 3, spaceBetween: 16 },   // small tablets
                900: { slidesPerView: 4, spaceBetween: 20 },   // tablets, small laptops
                1200: { slidesPerView: 5, spaceBetween: 20 },  // desktop
            },
            on: {
                resize: alignArrows,
                breakpoint: () => requestAnimationFrame(alignArrows),
            }
        });

        alignArrows();
        window.addEventListener('load', alignArrows);
    });

    // Video Sliders (thumbnails load first; the YouTube player only loads when someone presses play)
    document.querySelectorAll('.video-slider-section').forEach((section) => {

        const el = section.querySelector('.video-swiper');
        if (!el || el.swiper) return;

        // Center the arrows on the videos, not the titles under them
        const alignArrows = () => {
            const video = el.querySelector('.video-lite, .video-embed');
            if (!video) return;
            const top = video.offsetTop + video.offsetHeight / 2;
            section.querySelectorAll('.sw-arrow').forEach((arrow) => {
                arrow.style.top = top + 'px';
            });
        };

        // Swap any playing video back to its thumbnail, which stops it
        const stopVideos = () => {
            el.querySelectorAll('.video-embed').forEach((embed) => {
                if (embed._thumbnail) embed.replaceWith(embed._thumbnail);
            });
        };

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            rewind: true,
            watchOverflow: true,
            navigation: {
                nextEl: section.querySelector('.sw-arrow--next'),
                prevEl: section.querySelector('.sw-arrow--prev'),
            },
            pagination: {
                el: section.querySelector('.video-pagination'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
            },
            on: {
                slideChange: stopVideos,
                resize: alignArrows,
            }
        });

        alignArrows();
        window.addEventListener('load', alignArrows);

        el.addEventListener('click', (e) => {
            const thumbnail = e.target.closest('.video-lite');
            if (!thumbnail) return;
            stopVideos();
            const embed = document.createElement('div');
            embed.className = 'video-embed';
            const iframe = document.createElement('iframe');
            iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(thumbnail.dataset.videoId) + '?autoplay=1&rel=0&playsinline=1';
            iframe.title = thumbnail.getAttribute('aria-label') || 'YouTube video';
            iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            iframe.allowFullscreen = true;
            embed.appendChild(iframe);
            embed._thumbnail = thumbnail;
            thumbnail.replaceWith(embed);
        });
    });

    // Testimonials Swipers (one per section, so the section can be used on any page)
    document.querySelectorAll('.testimonials-section').forEach((section) => {

        const el = section.querySelector('.testimonials-swiper');
        if (!el || el.swiper) return;

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            rewind: true,
            grabCursor: true,
            watchOverflow: true,
            navigation: {
                nextEl: section.querySelector('.testimonials-next'),
                prevEl: section.querySelector('.testimonials-prev'),
            },
            pagination: {
                el: section.querySelector('.testimonials-pagination'),
                clickable: true,
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
            }
        });
    });
}


// Shopify Theme Editor Support
document.addEventListener('shopify:section:load', function () {

    console.log('Shopify section reloaded');

    initSwipers();

});
